// React Thirty Party Library
import React, { useState } from "react"
import { Form, Col, Row, Button, message } from "antd";
import { useDispatch, useSelector } from "react-redux";

// Constants Library
 
// Components Library
import { MainReport } from "../../components";
import { PrimaryButton } from "../../../../components/Decoration/Button";
import DriverSearchField from "./driverSearchField.js";
import showSecondarySidebar from '../../../../layout/MainLayout/helpers/showSecondarySidebar';

// Handler 
import { xlsx_handler } from "../../../../handlers/index.js";

import * as REDUX_ACTION from "../../../../services/redux/actions";

import { TIME, REDUX as REDUX_UTIL } from "../../../../services/util";
import { useNavigate } from "react-router";
import SetScheduleModal from "../../components/Pretrip/SetScheduleDrawer/index.js";

// Styles Library

const { 
  dayJSMilliSecond, lastNDay, currentTimeMilliSecond, 
  todayStart, todayEnd, parseExportTime, getCurrentMonthAndYear } = TIME

const { reduxStoreWrapper } = REDUX_UTIL;

const { exportReportFile } = xlsx_handler


const SearchReport = (props) => { 
  const { selectedType, setSelectedType, setShowTable, showTable, dataColumn, dataReport, fileName } = props;

  const loading = useSelector(reduxStoreWrapper("style.loading.report"));
  const drivers = useSelector(reduxStoreWrapper("drivers.byID"));

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const handleTypeChange = (value) => {
    setSelectedType(value);
    form.setFieldsValue({'type': value })
    setShowTable(false)
  };

  const onSearchReport = () => { 
    form
      .validateFields()
      .then((val) => {

        const { timeframe = [lastNDay(90), currentTimeMilliSecond()], drvids, month = getCurrentMonthAndYear() } = val
        setTimeframe(timeframe)

        const startTime = timeframe?.length && dayJSMilliSecond(timeframe[0])
        const endTime = timeframe?.length && dayJSMilliSecond(timeframe[1])
        const driver =  drvids[0] === 'All'
                      ? Object.values(drivers).map(d => d.drvid)
                      : drvids;

        switch(selectedType) {
            case 'performance': {
                dispatch(REDUX_ACTION.v3_reports.get_driver_report_summary_request({ startTime, endTime, drvids: driver }, () => { setShowTable(true) }))
                break;
            }
            case 'incident': {
                dispatch(REDUX_ACTION.v3_drivers.get_incidents_report_thru_drvids_request({ startTime, endTime, drvids: driver }, () => { setShowTable(true) }))
                break;
            }
            case 'pretrip': {
              // batch(() => {
                dispatch(REDUX_ACTION.v3_drivers.get_driver_pretip_by_drvid_request({
                    drvid: drvids[0],
                    startTime,
                    endTime
                }))
                // dispatch(REDUX_ACTION.v3_drivers.get_all_driver_checklist_request())
              // })
              break;
            }
            case 'driverScoring': {
                dispatch(REDUX_ACTION.v3_drivers.get_driver_performance_dashboard_data_request({
                    drvids: drvids,
                    month: month
                }))
                break
            }
        }
        
      }).catch(() => message.error('fill the form'))
  };

  const items = {
    form,
    handleTypeChange
  }

  const initial = {
    'type': selectedType,
    'timeframe': [todayStart, todayEnd],
  }

  const [ tf, setTimeframe ] = useState(null)
  const [ isOpenDrawer, setIsOpenDrawer ] = useState(false)

      const exportDataHandler = () => {

        exportReportFile(dataReport, dataColumn, "Main", `${fileName}_${parseExportTime(tf[0])}_${parseExportTime(tf[1])}`)
    }

const setScheduleBTNHDLR = () => {
    const { drvids = [], timeframe } = form.getFieldsValue()

    const startTime = timeframe?.length && dayJSMilliSecond(timeframe[0])
    const endTime = timeframe?.length && dayJSMilliSecond(timeframe[1])

    setIsOpenDrawer(true)

    dispatch(REDUX_ACTION.v3_drivers.set_schedule_pretrip_search_request({
        drvid: drvids[0],
        startTime,
        endTime
    }))
}

  return (
    <div style={{ marginLeft: '3em' }}>
        <Form layout="vertical" form={form} initialValues={initial} validateTrigger="onBlur">
          <Row >

            <DriverSearchField {...items} selectedType={selectedType} />

            {
                isOpenDrawer
                &&
                <SetScheduleModal isOpen={isOpenDrawer} setIsOpen={setIsOpenDrawer} />
            }
            
            {
                selectedType === 'pretrip'
                &&
                <Col>
                    <Button style = {{ marginLeft: '15px' }} color="primary" variant="outlined" onClick={setScheduleBTNHDLR}>
                        Set Schedule
                    </Button>
                </Col>
            }
            <Col>
               <PrimaryButton
                    loading = {loading}
                    onClick = {onSearchReport}
                    style = {{ marginLeft: '15px' }}
                    color='#ED5B57'
                >
                    Submit
                </PrimaryButton>
            </Col>
            <Col>
               <PrimaryButton
                    disabled = {!showTable}
                    onClick = {exportDataHandler}
                    style = {{ marginLeft: '15px' }}
                >
                    Export
                </PrimaryButton>
            </Col>

            {
                selectedType === 'incident'
                &&
                <div style={{ marginLeft: 'auto'}}>
                    <PrimaryButton onClick={() => navigate(`/create/driver/incident`)}>Add New</PrimaryButton>
                </div>
            }


          </Row>
        </Form>
    </div>
  );
};



const DriverReport = () => {
    const mode = useSelector(reduxStoreWrapper('reports.mode'))
    const drivers = useSelector(reduxStoreWrapper("drivers"));



  return (
    <>
     <MainReport type={mode || 'attendance'} search={<SearchReport />} startTime={drivers.startTime} endTime={drivers.endTime}/>
    </>
  );
};

const MemorizedDriverReport = React.memo(DriverReport);

export default showSecondarySidebar(false)(MemorizedDriverReport);